












































import { Component, Vue } from 'vue-property-decorator';
import CommonInput from "@/components/common/CommonInput.vue";
import SecureInput from "@/components/common/SecureInput.vue";
import InputRules from "@/utils/InputRules";
import {AuthService} from "@/services/AuthService";
import {get} from "@/context/context";
import {UserResponse} from "@/models/User/UserResponse";
import ApiErrors from "@/utils/ApiErrors";
import API from "@/utils/Api";
import CommonButton from "@/components/common/CommonButton.vue";
import {defaultServer, Servers, urls} from "@/serverConfig";

@Component({
  components: {
    CommonButton,
    CommonInput,
    SecureInput
  },
})
export default class Login extends Vue {
  private authService: AuthService = get('authService');
  private api: API = get('api');

  private formValid: boolean = true;
  private formData = {
    email: '',
    password: '',
  };
  private formErrors = {
    email: '',
    password: '',
  };

  get rules() {
    return {
      email: [
        (v: any) => InputRules.required(v) || this.$t('login_page.form.inputs.email.required_error'),
        (v: any) => InputRules.emailTest(v) || this.$t('login_page.form.inputs.email.invalid_error'),
      ],
      password: [
        (v: any) => InputRules.required(v) || this.$t('login_page.form.inputs.password.required_error'),
        (v: any) => InputRules.min(v, 8) || this.$t('login_page.form.inputs.password.length_error'),
      ]
    }
  }
  private isLogging: boolean = false;

  private clearErrors() {
    this.formErrors = {
      email: '',
      password: '',
    }
  }

  private async validate() {
    (this.$refs.form as any).validate();
  }

  private async handleSubmit() {
    const selectServer = defaultServer;
    this.isLogging = true;
    this.clearErrors();
    await this.validate();
    if (!this.formValid) {
      this.isLogging = false;
      return;
    }

    try {
      this.api.changeServer(selectServer); // select server
      const data = await this.authService.login(this.formData.email, this.formData.password);
      const user = data as UserResponse;

      Promise.all( Object.keys(urls).map(async (key: string) => {
        if (key !== selectServer) {
          this.api.changeServer(key);
          let otherServer = await this.authService.getTokenByEmail(this.formData.email);
          let otherInfo = otherServer as UserResponse;
          this.authService.setUserAuth(key, otherInfo);
        }
      })).then(() => {
        this.authService.setUserAuth(selectServer, user);
        this.isLogging = false;
        this.$router.push("/");
      })

    } catch (e) {
      this.isLogging = false;
      switch (e.response.data.code) {
        case (ApiErrors.LOGIN_INVALID): {
          this.formErrors.email = this.$t('login_page.form.inputs.email.invalid_error').toString();
          break;
        }
        default: {
          this.formErrors.email = this.$t('login_page.form.inputs.email.invalid_error').toString();
        }
      }
    }

  }
}
